import { useTranslations } from '@vocab/react';

import { Status } from '../Status/Status';

import translations from './.vocab';

const getWorkTypesText = (translatedWorkTypes: string[]) => {
  if (!translatedWorkTypes || translatedWorkTypes.length === 0) {
    return '-';
  }
  return translatedWorkTypes.length > 1
    ? translatedWorkTypes.join(', ')
    : translatedWorkTypes[0];
};

export const WorkTypesStatus = ({
  label,
  workTypes,
}: {
  label: string;
  workTypes: string[];
}) => {
  const { t } = useTranslations(translations);

  const WORK_TYPE_TEXT_VALUES: Record<string, string> = {
    fulltime: t('FULL_TIME'),
    parttime: t('PART_TIME'),
    contract: t('CONTRACT'),
    casual: t('CASUAL'),
    unspecified: t('UNSPECIFIED'),
  } as const;

  const translatedWorkTypes =
    workTypes &&
    workTypes.map((workType) => WORK_TYPE_TEXT_VALUES[workType.toLowerCase()]);

  return <Status label={label} text={getWorkTypesText(translatedWorkTypes)} />;
};
